// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"432":"65f10396","540":"73cf9f76","655":"f95e6676"}[chunkId] + ".chunk.js";
};